import axiosClient, { token } from '../helpers/axios_client';
import graphClient from '../graphql/graph_client';
import { auth, signOut } from '../firebase/auth';

declare global {
  interface Window {
    user?: unknown;
    mixpanel?: { reset?: () => void };
  }
}

const clearClientAuthState = () => {
  delete axiosClient.defaults.headers.common['Authorization'];
  try {
    graphClient.setHeaders({
      'X-CSRF-Token': token.content,
      App: 'Web',
    });
  } catch (error) {
    console.warn('Failed to reset GraphQL client headers during logout:', error);
  }

  if (typeof window !== 'undefined') {
    window.user = null;
    window.mixpanel?.reset?.();
  }
};

export const performLogout = async (): Promise<void> => {
  let firebaseError: unknown;
  let backendError: unknown;

  try {
    await signOut(auth);
  } catch (error: any) {
    if (error?.code !== 'auth/no-current-user') {
      console.error('Firebase sign-out failed:', error);
      firebaseError = error;
    }
  }

  try {
    await axiosClient.delete('/logout', {
      headers: { Accept: 'application/json' },
    });
  } catch (error: any) {
    if (error?.response?.status !== 401) {
      console.error('Backend logout failed:', error);
      backendError = error;
    }
  }

  clearClientAuthState();

  if (backendError || firebaseError) {
    throw (backendError || firebaseError) as Error;
  }
};

export default performLogout;
